import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../../services/data.service';
import { School } from '../../model/school';
import { SortingService } from '../../services/sort.service';
import { FormGroup } from '@angular/forms';

@Component({
    selector: 'error404',
    templateUrl: './error404.component.html'
})

export class Error404Component {
    schoolSignupForm: FormGroup;
    monthNums: number[] = [1,2,3,4,5,6,7,8,9,10,11,12];
    yearNums: number[] = [new Date().getFullYear(), new Date().getFullYear()+1, new Date().getFullYear()+2, new Date().getFullYear()+3, new Date().getFullYear()+4, new Date().getFullYear()+5, new Date().getFullYear()+6, new Date().getFullYear()+7, new Date().getFullYear()+8, new Date().getFullYear()+9, new Date().getFullYear()+10, new Date().getFullYear()+11, new Date().getFullYear()+12, new Date().getFullYear()+13];
    constructor (
        private router: Router,
        private dataSvc: DataService,
        private sortSvc: SortingService
    ) {
    }

    ngOnInit() {
    }
}